module.exports = __webpack_public_path__ + "static/img/siwei2.74a1754e.png";